import Icon from '../../components/Icon.vue'

Icon.register({"brands/gitter":{"width":384,"height":512,"paths":[{"d":"M66.4 322.5H16V0H66.4V322.5zM166.9 76.1H116.5V512H166.9V76.1zM267.5 76.1H217.1V512H267.5V76.1zM368 76H317.6V323H368V76z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/gitter.js
// module id = null
// module chunks = 